export const readLocalStorage = <T>(key: string, defaultValue: T) => {
    const data = localStorage.getItem(key);
    return data ? (JSON.parse(data) as T) : defaultValue;
};
export const writeLocalStorage = (key: string, data: unknown) => {
    localStorage.setItem(key, JSON.stringify(data));
};
export const removeLocalStorageItem = (key: string) => {
    localStorage.removeItem(key);
};
